export default "__VITE_ASSET__DybYwWLG__";